var map = {
	"./04_spot_trader_sell_order.json": "ByM2",
	"./10_spot_trader_detail.json": "jHm3",
	"./11_spot_trader_profit_summary.json": "ZPIr",
	"./12_spot_trader_profit_detail.json": "r/nZ",
	"./13_spot_trader_order_history.json": "CsM4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "FD0t";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/copyTrade/api/spotTrader \.json$
// module id = FD0t
// module chunks = 3